import type { MaybeRef } from '@vueuse/core'
import type { ElemetalInfosData } from '../api/elementals'
import type { Elemental } from '../types/elemental'
import { useUpVoteMutation } from './mutations/upvote/useUpvoteMutation'

export function useUpvote(element: MaybeRef<Elemental | null | undefined>, infos: Ref<ElemetalInfosData | null | undefined>) {
  const firebaseUser = useUser()
  const router = useRouter()
  const { mutate, isPending } = useUpVoteMutation()
  const isAuth = computed(() => firebaseUser.value !== null)
  const isVoted = computed(() => infos.value?.isVoted ?? false)

  const upvote = () => {
    const elemental = unref(element)
    if (!elemental)
      return
    if (!isAuth.value) {
      const path = useGetLoginURL()
      return router.push(path)
    }
    mutate({
      elemental: {
        ...elemental,
        isVoted: infos.value?.isVoted ?? false,
      },
      elementalType: elemental.isList ? ElementalTypeEnum.List : elemental.elementalTypeId!,
    },
    )
  }

  return {
    isPending,
    upvote,
    isVoted,
  }
}
